import type { ItineraryProduct } from '@/types/products';

const isOfType =
  <T extends ItineraryProduct['type']>(targetType: T) =>
  (product: ItineraryProduct): product is ItineraryProduct & { type: T } =>
    product.type.toLowerCase() === targetType;

/**
 * Get all itinerary products of a certain type, typed correctly for typescript to understand
 * @param intineraryProducts all itinerary products
 * @param targetType type of the itinerary product
 * @returns
 */
export const getItineraryProductsOfType = <T extends ItineraryProduct['type']>(
  intineraryProducts: ItineraryProduct[],
  targetType: T,
): (ItineraryProduct & { type: T })[] =>
  intineraryProducts.filter(isOfType(targetType)) as (ItineraryProduct & { type: T })[];
